import { formatCount } from 'src/pages/AnalyticsPage/components/heroStatHelpers'
import { StackedBar } from 'src/pages/AnalyticsPage/components/StackedBar'

// Staffed = brand-100, off-hours = brand-600. Hex because StackedBar segments
// take CSS colors, not Tailwind classes.
const STAFFED_COLOR = '#BBDFF3'
const STAFFED_TEXT_COLOR = '#344054' // gray-700
const OFF_HOURS_COLOR = '#1676AC'
const OFF_HOURS_TEXT_COLOR = '#FFFFFF'

export interface CoverageBarProps {
  /** Row label, e.g. "All" / "Employees" / "Voice agent". */
  label: string
  staffed: number
  offHours: number
}

/**
 * One staffed-vs-off-hours row. The view stacks one per actor (All /
 * Employees / Voice agent) so the voice agent's off-hours share — the product
 * value — reads by comparing rows, without a toggle.
 */
export const CoverageBar = ({ label, staffed, offHours }: CoverageBarProps) => {
  const total = staffed + offHours
  const offPct = total > 0 ? Math.round((offHours / total) * 100) : 0
  const testId = `coverage-bar-${label.toLowerCase().replace(/\s+/g, '-')}`

  return (
    <div className="flex items-center gap-2.5" data-testid={testId}>
      <div className="w-24 shrink-0 text-[11px] font-medium text-doubleNickel-gray-600">
        {label}
        <span className="block text-[13px] font-semibold text-doubleNickel-gray-800">
          {formatCount(total)}
        </span>
      </div>
      <StackedBar
        className="flex-1"
        height={24}
        inlineLabels
        segments={[
          {
            id: 'staffed',
            value: staffed,
            color: STAFFED_COLOR,
            textColor: STAFFED_TEXT_COLOR,
            label: `Staffed · ${formatCount(staffed)}`,
          },
          {
            id: 'offHours',
            value: offHours,
            color: OFF_HOURS_COLOR,
            textColor: OFF_HOURS_TEXT_COLOR,
            label: `Off-hours · ${formatCount(offHours)} (${offPct}%)`,
          },
        ]}
      />
    </div>
  )
}

export default CoverageBar
